import React from "react";
import { Space } from "../../components/space/Space";
import { IFilterInputProps } from "./definitions";
import { useFilterSheets } from "./hooks";
import { useAppDispatch } from "../../app/store/hooks";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Input from "@amzn/meridian/input";

export const FilterInput: React.FC<IFilterInputProps> = ({ inputInfo }) => {
    const dispatch = useAppDispatch();
    const { filterMap, handleFilterMapUpdate } = useFilterSheets();

    return (
        <Box>
            <Text type={"h100"}> {inputInfo.label}</Text>
            <Space size={"xxs"} />
            <Input
                value={filterMap.get(inputInfo.keyValue)?.value || ""}
                onChange={selectedValue =>
                    dispatch(
                        handleFilterMapUpdate({
                            type: "UPDATE",
                            filterKey: inputInfo.keyValue,
                            value: selectedValue,
                        })
                    )
                }
                type={inputInfo.inputType}
                placeholder={inputInfo.placeholder}
                size="medium"
            />
        </Box>
    );
};
